/* tslint:disable:object-literal-key-quotes */

import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { Component } from '@gondel/core';
import { dispatchCustomEvent, EventNames } from '@swisslife/shared-ui/src/utils/custom-event/js/custom-event';
import { initYoutube, IInitYoutubeReturn } from './initYoutube';
import { initXtendx, IInitXtendxReturn } from './initXtendx';
import { init3q, IInit3qReturn } from './init3q';
import { initMovingImage, IInitMovingImageReturn } from './initMovingImage';

const initPlayerMap = {
	youtube: async (patternContext) => initYoutube(patternContext),
	movingImage: async (patternContext) => initMovingImage(patternContext),
	xtendx: async (patternContext) => initXtendx(patternContext),
	'3q': async (patternContext) => init3q(patternContext),
};

export type PlayerEventCallbackFn = (
	playerType: TPlayerType,
	playerEvent: EventNames,
	videoId: string,
	videoName: string,
	videoProgress?: number
) => void;

export type TPlayerType = keyof typeof initPlayerMap;

type TInitPlayerReturn = IInitYoutubeReturn | IInitXtendxReturn | IInit3qReturn | IInitMovingImageReturn | undefined;

@Component('Video')
export class Video extends GondelJqueryComponent {
	private initPlayerReturn: TInitPlayerReturn;

	public async initVideoPlayer(): Promise<boolean> {
		this.initPlayerReturn = await this.fetchPlayer();

		if (this.initPlayerReturn) {
			this.initPlayerReturn.addEventCallback(this.playerEventCallback);
		}

		this.appendPlayerToMarkup(this.initPlayerReturn);

		return true;
	}

	public removePlayer(): void {
		if (!this.initPlayerReturn) {
			return;
		}

		this.initPlayerReturn.remove();
	}

	private async fetchPlayer(): Promise<TInitPlayerReturn> {
		const provider = this.$ctx.data('provider');
		if (!initPlayerMap[provider]) {
			return;
		}
		return await initPlayerMap[provider](this);
	}

	private appendPlayerToMarkup(player: string | any): void {
		if (typeof player.markup !== 'string') {
			return;
		}
		this.$ctx.append(player.markup);
	}

	private playerEventCallback: PlayerEventCallbackFn = (
		playerType: TPlayerType,
		playerEvent: EventNames,
		videoId: string,
		videoName: string,
		videoProgress?: number
	) => {
		dispatchCustomEvent(this.$ctx, playerEvent, { videoPlayer: playerType, videoId, videoName, videoProgress });
	};
}
/* tslint:enable:object-literal-key-quotes */
